import { text } from './text';

const palette = {
  50: '#fdfde5',
  100: '#fbf8bf',
  200: '#f8f494',
  300: '#f5f068',
  400: '#f2eb42',
  500: '#efe605',
  600: '#f2d600',
  700: '#f2be00',
  800: '#f3a500',
  900: '#f27a00',
};

export const yellow = {
  ...palette,
  light: palette[300],
  main: palette[600],
  dark: palette[800],
  darker: palette[900],
  contrastText: text.contrast,
};
